// extracted by mini-css-extract-plugin
export var fadeIn = "_eb-1";
export var modalContent = "_eb-3";
export var overlay = "_eb-0";
export var popoverContent = "_eb-2";
export var results = "_eb-5";
export var searchInputWrapper = "_eb-4";